/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtext_Loading1Inputs */

const vi_richtext_loading1 = /** @type {(inputs: Richtext_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải trình soạn nội dung…`)
};

/**

* @param {Richtext_Loading1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const richtext_loading1 = /** @type {((inputs?: Richtext_Loading1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtext_Loading1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_richtext_loading1(inputs)
});
export { richtext_loading1 as "richText_loading" }